/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DentalPlanRepeater/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import Repeater from 'DesignSystem/Repeater/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function DentalPlanRepeater({
  children,
  viewPath = "/App/Form/Data/ReviewData/DentalPlanRepeater",
  text
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<Repeater
  viewPath={`${viewPath}/Repeater`}
 label="Dental Plan"
 onClick={() => setFlowTo("/App/Form/Data/ProvideData/DentalPlan")}
 isSelected={flow.has("/App/Form/Data/ProvideData/DentalPlan")}
 text={text}
/>
{children}
</React.Fragment>)
}